export function transformEarnReport(reports) {
  // Validate Report
  if (!reports) return [];

  return reports.map((report) => {
    // Get Report
    const {
      user_id: userId,
      user_verify: userVerify,
      coin,
      home_id: homeId
    } = report;

    // Set Default
    const result = {
      ...report,
      user_wallet_id: userId ? `rj-${userId}` : '-',
    };

    // Validate Coin
    if (coin && coin.current_token_name) {
      result.mnc_year = coin.current_token_name;
    }

    // Validate User Profiles
    if (userVerify) {
      // Get User Verify
      const {
        centralize_user: centralizeUser,
        user_homes: userHomes,
        user_profiles: userProfiles
      } = userVerify;

      // Get Centralize User
      if (centralizeUser) {
        const { email, sc_employee_id: scEmployeeId } = centralizeUser;
        result.email = email;
        result.employee_id = scEmployeeId;
      }

      // Get User Home
      if (userHomes && userHomes.length > 0) {
        let status = userHomes[0].user_role;

        const userHome = userHomes.find(
          (val) => val.home_id === homeId
        );

        if (userHome) {
          status = userHome.user_role;
        }

        result.user_home_status = status;
      }

      // Get User Profile
      if (userProfiles) {
        result.mobile_number = userProfiles.mobile_number;
      }
    }

    return result;
  });
}
